import moment from 'moment';

export const formatTimeForPicker = (
  date: string,
  twleveHourFormatTime: string,
) => {
  const twentyFourHourFormat = moment(twleveHourFormatTime, ['h:mm A']).format(
    'HH:mm',
  );
  const dateWithTime = `${date} ${twentyFourHourFormat}`;
  return dateWithTime;
};

export const formatTimeToString = (pickedTime: any, shortFormat?: boolean) => {
  const data = new Date(pickedTime);
  const hrs = data.getHours();
  const suffix = hrs >= 12 ? 'PM' : 'AM';
  const mins = data.getMinutes();
  let formattedTime: any = '';
  if (shortFormat) {
    formattedTime = `${`0${((hrs + 11) % 12) + 1}`.slice(-2)}:00 ${suffix}`;
  } else {
    formattedTime = `${((hrs + 11) % 12) + 1}:${mins} ${suffix}`;
  }
  return formattedTime;
};

export const convertTime12to24 = (time12h: string) =>
  moment(time12h, 'hh:mm A').format('HH:mm');

export const addHoursToTime = (startDateTime: string, hours: number) =>
  moment(startDateTime, "MM-DD-YYYY HH:mm").add(hours, 'hours').format('HH:mm');
